<div class="box">
    <img src="/assets/img/404.png" width="380">
    <p>{{ translate.instant('ENTRY.NOTFOUND.THE_PAGE_YOURE_LOOKING_FOR_CANT_BE_FOUND') }}</p>
    <button class="buttonGrey"  (click)="goBack()">{{
        translate.instant('ENTRY.NOTFOUND.GO_HOME') }}</button>
</div>